export const EXTERNAL_LOADING_SLICE = 'EXTERNAL_LOADING_SLICE';
